import { PublicKey } from "@solana/web3.js";
import { USDC_DECIMALS, UXD_DECIMALS } from "@uxd-protocol/uxd-client";
import { SlippageOptions } from "../components/slippage/Slippage";
import ClusterRPCEndpoint from "../solana/clusterRPCEndpoint";
import {
  ISolanaConfiguration,
  ClusterRPCEndpoints,
  CollateralMints,
  CounterpartMints,
  OtherMints,
} from "./solana.types";
import { ClusterName, Programs } from "./types";
import AUXDSolanaBaseConfig from "./uxd.solana.base";

const UXP_DECIMALS = 9;

const USDC_INFO = {
  mint: new PublicKey("EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v"),
  //mint: new PublicKey("9ZzK3pwvVUgwuFe5kjHo1V9kzmmQ6nJMPMQyTVQPwzuM"), // TEST USDC FOR MAINNET
  decimals: USDC_DECIMALS,
};

const PRIMARY_RPC_ENDPOINTS = [
  // TO DELETE (DEV ONLY)
  new ClusterRPCEndpoint(
    "https://mainnet.helius-rpc.com/?api-key=d532feaa-dfbd-4a99-ad63-c735fd14d143"
  ),
  new ClusterRPCEndpoint(
    "https://compatible-billowing-isle.solana-mainnet.quiknode.pro/146497e3f11e861b89e906400e73b765b5d739eb/"
  ),
  //
];

const SECONDARY_RPC_ENDPOINTS = [
  new ClusterRPCEndpoint("https://api.mainnet-beta.solana.com"),
  new ClusterRPCEndpoint("https://solana-api.projectserum.com"),
];

class UXDMainnetConfig
  extends AUXDSolanaBaseConfig
  implements ISolanaConfiguration
{
  // LET IT EMPTY FOR NOW SO IT CAN'T BE USED ON MAINNET
  protected governanceRealmAccountPubkey = null as unknown as PublicKey;
  protected governanceProgramPubkey = null as unknown as PublicKey;

  protected collateralMints: CollateralMints = {
    USDC_IDENTITY: {
      ...USDC_INFO,
      name: "USDC_IDENTITY",
      displayName: "USDC",
      features: ["mint", "redeem"],
    },
    USDC_MERCURIAL: {
      ...USDC_INFO,
      name: "USDC_MERCURIAL",
      displayName: "USDC",
      features: ["mint", "redeem"],
    },
    USDC_CREDIX: {
      ...USDC_INFO,
      name: "USDC_CREDIX",
      displayName: "USDC",
      features: ["mint", "redeem"],
    },
  };

  protected counterpartMints: CounterpartMints = {
    USDC: {
      ...USDC_INFO,
      name: "USDC",
    },
    UXD: {
      mint: new PublicKey("7kbnvuGBxxj8AG9qp8Scn56muWGaRaFqxg1FsRp3PaFT"),
      // mint: new PublicKey("9BxgG2CqDL4kqERLP54N4vxEj7fygp6jtst8JFy4DfTK"),
      decimals: UXD_DECIMALS,
      name: "UXD",
    },
  };

  protected otherMints: OtherMints = {
    UXP: {
      //mint: new PublicKey("7NQz61WtEmCr2jUvaLX779H553WmuvhkXsaZuzzE8ygx"), // TEST UXP FOR MAINNET
      mint: new PublicKey("UXPhBoR3qG4UCiGNJfV7MqhHyFqKN68g45GoYvAeL2M"),
      decimals: UXP_DECIMALS,
      name: "UXP",
    },
    UCT: {
      //mint: new PublicKey("BejCTT4F157MptAgL7fe8BVHuxpD4PRtZKFaJTrKAbEF"), // TEST UCT FOR MAINNET
      mint: new PublicKey("5wZoku5mujk4773ZzgbF5cFCC2eMyj3Cx54CHhrukmRM"),
      decimals: 9,
      name: "UCT",
    },
  };

  protected programs: Programs = {
    uxd: {
      // address: new PublicKey("EmXCGBmeZ7vTZu1NcuR5Cod8438aQdghhVa69zcBVF23"),
      address: new PublicKey("UXD8m9cvwk4RcSxnX2HZ9VudQCEeDH6fRnB4CAP57Dr"),
    },
    staking: {
      address: new PublicKey("UXDSkps5NR8Lu1HB5uPLFfuB34hZ6DCk7RhYZZtGzbF"),
    },
    credix: {
      address: new PublicKey("CRDx2YkdtYtGZXGHZ59wNv1EwKHQndnRc1gT4p8i2vPX"),
    },
    redemption: {
      //address: new PublicKey("2VZHSai5z2B9Lm6vxfm8sqgzLRmTdhdsDZ6Z2Ppjz8kg"), // TEST PROGRAM ID for MAINNET
      address: new PublicKey("UXDReVg1YMckS2eVFh7TyhWDuDPaqF3wW8fX2NKeCGz"),
    },
  };

  protected clusterRPCEndpoints: ClusterRPCEndpoints = [
    ...PRIMARY_RPC_ENDPOINTS,
    ...SECONDARY_RPC_ENDPOINTS,
  ];

  protected stakingCampaign: PublicKey = new PublicKey(
    "GMkG1Xr1ZAtLbHRxfbqLFEHqjP7rGwEfhQFed41aEL1k"
  );

  protected defaultSlippage: SlippageOptions = "0.5";

  protected clusterName: ClusterName = "mainnet-beta";

  protected mercurialCollateralMint = {
    mint: new PublicKey("EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v"),
    decimals: USDC_DECIMALS,
    symbol: "USDC" as const,
    name: "USDC" as const,
  };
}

const UXDMainnetConfigInstance = new UXDMainnetConfig();

export default UXDMainnetConfigInstance;
